// biome-ignore lint/style/noRestrictedImports: only using types
import type { OidcConfiguration as IOidcConfiguration } from '@axa-fr/react-oidc';
import type { AppConfig } from 'modules/config/appConfig';
import { isTokenExpired } from './authHelpers';

export class AuthService {
  OidcConfiguration: IOidcConfiguration | undefined;
  LogoutUri: string | undefined;
  init(config: AppConfig) {
    this.OidcConfiguration = {
      authority: config.stsConfig.authority,
      client_id: config.stsConfig.clientId,
      redirect_uri: `${config.stsConfig.appUrl}/authorization/callback`,
      scope: config.stsConfig.scope,
      service_worker_only: false,
      storage: localStorage,
      token_renew_mode: 'access_token_or_id_token_invalid',
      refresh_time_before_tokens_expiration_in_second: 50,
    };
    this.LogoutUri = config.stsConfig.post_logout_redirect_uri;
  }

  loggedIn() {
    const token = this.getToken();
    if (!!token && !isTokenExpired(token)) {
      return true;
    }
    return false;
  }

  shouldRefreshExistingToken() {
    const token = this.getToken();
    return token && isTokenExpired(token);
  }

  getToken(): string {
    const oidcNode = localStorage.getItem('oidc.default');
    if (typeof oidcNode !== 'string') return '';
    const parsedValue = JSON.parse(oidcNode);
    if (parsedValue.tokens === null) return '';

    return parsedValue.tokens.accessToken;
  }

  hasToken() {
    return !!this.getToken();
  }

  getValidToken() {
    return this.getToken();
  }
}
